import React from "react"
import { Navigate } from "react-router-dom"
import Spinners from "components/Shared/Spinners"
import { useAssignedBrands, getBrandOrdersBasePath } from "hooks/useAssignedBrands"
import OrdersBrandPicker from "./OrdersBrandPicker"

const OrdersHub = () => {
  const { brands, loading, loaded } = useAssignedBrands()

  if (loading || !loaded) {
    return <Spinners />
  }

  if (!brands.length) {
    return <OrdersBrandPicker brands={[]} />
  }

  if (brands.length === 1) {
    return <Navigate to={getBrandOrdersBasePath(brands[0].brandId)} replace />
  }

  return <OrdersBrandPicker brands={brands} />
}

export default OrdersHub
